/* eslint-disable max-len */
import { VStack, Box, Flex } from "@chakra-ui/react";
import { BodyShort } from "@digital-services-gard-as/anchor-react";
import { t } from "i18next";

type NoResultsProps = {
    messages?: string[];
};

export const NoResults = ({ messages }: NoResultsProps) => {
    const textMessages = messages ?? [t("common:noSearchResults.message1"), t("common:noSearchResults.message2")];

    return (
        <VStack py={12} px={4} textAlign="center" color="gray.600" gap={5}>
            <Box boxSize="120px">
                <svg viewBox="0 0 136 115" width="100%" height="100%" fill="none">
                    <path
                        d="M68.3507 102.811C96.4347 102.811 119.201 79.9642 119.201 51.7807C119.201 23.5972 96.4347 0.75 68.3507 0.75C40.2666 0.75 17.5 23.5972 17.5 51.7807C17.5 79.9642 40.2666 102.811 68.3507 102.811Z"
                        fill="#FAEAEE"
                        stroke="#2C2C34"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />

                    <path
                        d="M75.8936 52.1706C75.8936 52.1706 76.1915 52.4696 75.2978 53.0675C74.4041 53.6655 68.4458 55.4593 65.7646 54.2634C63.0834 53.0675 62.7855 51.8717 62.7855 51.8717C56.6872 44.3796 58.3704 33.7871 58.9692 30.9888C59.568 28.1905 71.9374 18.5787 80.0614 27.3025C88.1825 36.0294 80.6483 37.9547 80.6483 37.9547"
                        fill="white"
                        stroke="#2C2C34"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />

                    <path
                        d="M64.7922 34.4365C64.7922 34.4365 63.5975 40.0332 67.1069 44.6164C72.3144 54.264 62.7812 51.8723 62.7812 51.8723"
                        stroke="#2C2C34"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />

                    <path
                        d="M62.4844 33.9342C62.4844 33.9342 71.7197 35.728 80.0612 31.5425"
                        stroke="#2C2C34"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />

                    <path
                        d="M80.0644 31.5424L81.0773 41.199C81.0773 41.199 81.122 42.7506 80.6304 44.6012C80.2729 45.9496 79.6324 47.4564 78.4795 48.6343C76.5639 50.2487 75.8906 52.1711 75.8906 52.1711"
                        fill="white"
                        stroke="#2C2C34"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />

                    <path
                        d="M29.5859 104.363L30.6942 107.201"
                        stroke="#2C2C34"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />

                    <path
                        d="M80.362 71.605C80.362 71.605 105.631 71.892 103.599 66.5226C101.216 54.8628 93.0709 41.2957 93.0709 41.2957L84.5327 41.1104L89.8952 56.9048C89.6181 56.9407 79.4414 56.4055 79.4414 56.4055L80.362 71.605Z"
                        fill="white"
                        stroke="#2C2C34"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />

                    <path
                        d="M27.8683 96.7613C27.8683 96.7613 27.4959 85.9805 31.5028 74.5959C36.4124 60.6371 50.5692 54.5651 50.5692 54.5651L51.165 69.2145C51.165 69.1875 44.465 76.3927 41.6318 79.0804C38.9953 81.5797 34.4134 98.8899 34.4134 98.8899C34.4134 98.8899 34.0857 107.491 33.758 109.025C33.4303 110.559 32.2119 109.925 31.911 109.614C31.6101 109.303 31.0113 108.011 31.0113 108.011L30.6597 107.109L30.5376 106.795C30.5376 106.795 29.1136 112.343 27.8713 113.557C26.629 114.771 25.4194 113.521 25.1245 112.595C24.8296 111.668 24.3112 104.89 24.633 103.972C24.9517 103.055 27.8713 96.7613 27.8713 96.7613H27.8683Z"
                        fill="white"
                        stroke="#2C2C34"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />

                    <path
                        d="M119.65 43.0044H119.501L105.74 42.6008L75.8598 41.7367C74.3226 41.659 73.125 40.5827 73.125 39.2822C73.125 38.6574 73.4021 38.0834 73.8638 37.6469C74.3256 37.2104 74.9691 36.9114 75.7049 36.8426L105.204 34.436L118.58 33.3447L119.635 42.8638L119.65 43.0044Z"
                        fill="white"
                        stroke="#2C2C34"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />

                    <path
                        d="M119.076 43.7913C121.915 43.7913 124.218 41.2816 124.218 38.1857C124.218 35.0898 121.915 32.5801 119.076 32.5801C116.236 32.5801 113.934 35.0898 113.934 38.1857C113.934 41.2816 116.236 43.7913 119.076 43.7913Z"
                        fill="white"
                        stroke="#2C2C34"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />

                    <path
                        d="M90.1912 57.5543C90.1912 57.5543 81.8944 54.0863 75.8914 52.1729C69.099 55.7635 62.7833 51.8739 62.7833 51.8739C62.7833 51.8739 52.9522 52.1729 48.1856 55.7605C48.1856 55.7605 46.6305 67.2408 50.271 70.7088C49.3772 85.3582 50.8668 99.7086 50.8668 99.7086C67.5499 105.987 83.3392 100.606 83.3392 100.606L84.4564 69.498C86.5895 69.0974 85.5051 69.3485 85.7583 69.1662C92.5268 64.2511 90.1912 57.5543 90.1912 57.5543Z"
                        fill="white"
                        stroke="#2C2C34"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />

                    <path
                        d="M58.3166 65.329C57.6612 65.329 57.125 65.8671 57.125 66.5248V69.7627C57.125 70.4204 57.5897 71.2246 58.1617 71.5505L59.8449 72.5132C60.414 72.839 61.3464 72.839 61.9154 72.5132L63.834 71.4189C64.403 71.0931 64.8707 70.2888 64.8707 69.6311V66.5278C64.8707 65.8701 64.3345 65.332 63.6791 65.332H58.3166V65.329Z"
                        fill="white"
                        stroke="#2C2C34"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                </svg>
            </Box>
            {textMessages.length > 0 && (
                <Flex direction="column" gap={2} alignItems="center">
                    {textMessages.map((message, index) => (
                        <BodyShort key={`${index}-${message}`} size="md">
                            {message}
                        </BodyShort>
                    ))}
                </Flex>
            )}
        </VStack>
    );
};
